<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Transaction Histories</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Transaction Histories</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>

    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <div class="btn-toolbar pull-right">
              <el-dropdown split-button :trigger="'click'"
                           @command="handleSelectedRows"
                           type="primary" v-if="this.selected_row.length" class="mr-1">
                {{ this.selected_row.length }} {{ 'item' | pluralize(this.selected_row.length) }} selected
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="delete">Delete Selected Items</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <button class="btn btn-info" type="button" @click="showFilter = !showFilter">
                <i class="fa fa-filter"></i> Filter
              </button>
            </div>

            <div class="card-tools">
              <!--<router-link :to="{ name: 'EWTrxHistoryAdd'}" class="btn btn-success" v-if="actionCreate">
                <i class="fas fa-plus"></i> New
              </router-link>-->
              <button class="btn btn-info" @click="exportFile()">
                <i class="fas fa-download"></i> Export
              </button>

            </div>
          </div>

          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="sender_user_id">Sender UserId</label>
                    <div class="col-md-9">
                      <input type="text" id="sender_user_id" class="form-control" v-model="filter.sender_user_id"
                             placeholder="Sender User Id">
                    </div>
                  </div>

                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="receiver_user_id">Receiver UserId</label>
                    <div class="col-md-9">
                      <input type="text" id="receiver_user_id" class="form-control" v-model="filter.receiver_user_id"
                             placeholder="Receiver User Id">
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="status">Activity Type</label>
                    <div class="col-md-9">
                      <select class="form-control" style="width: 100%;" id="trx_activity_type_id"
                              name="trx_activity_type_id"
                              v-model="filter.trx_activity_type_id">
                        <option v-for="(val, index) in activityTypes" :value="val.value">{{ val.label }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="owner_id">Owner Id</label>
                    <div class="col-md-9">
                      <input type="text" id="owner_id" class="form-control"
                             v-model="filter.owner_id"
                             placeholder="Owner Id">
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="trx_type">Type</label>
                    <div class="col-md-9">
                      <select class="form-control" style="width: 100%;" id="trx_type" name="trx_type"
                              v-model="filter.trx_type">
                        <option value="in">In</option>
                        <option value="out">Out</option>
                      </select>
                    </div>

                    <label class="col-md-3 col-form-label" for="is_charge">Is Charge</label>
                    <div class="col-md-9">
                      <select class="form-control" style="width: 100%;" id="is_charge" name="is_charge"
                              v-model="filter.is_charge">
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="trx_note">Note</label>
                    <div class="col-md-9">
                      <input type="text" id="trx_note" class="form-control" v-model="filter.trx_note"
                             placeholder="Note">
                    </div>
                  </div>

                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="trx_uuid">UUID</label>
                    <div class="col-md-9">
                      <input type="text" id="trx_uuid" class="form-control" v-model="filter.trx_uuid"
                             placeholder="Transaction UUID">
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="trx_amount">Amount</label>
                    <div class="col-md-9">
                      <input type="text" id="trx_amount" class="form-control" v-model="filter.trx_amount"
                             placeholder="Transaction Amount">
                    </div>
                  </div>

                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="balance">Balance</label>
                    <div class="col-md-9">
                      <input type="text" id="balance" class="form-control" v-model="filter.balance"
                             placeholder="Balance">
                    </div>
                  </div>
                </div>

                <div class="col-md-6">

                  <div class="form-group from-row">
                    <label class="col-md-3 col-form-label" for="trx_reference">Reference</label>
                    <div class="col-md-9">
                      <input type="text" id="trx_reference" class="form-control" v-model="filter.trx_reference"
                             placeholder="Transaction Reference">
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="created_at">Date range</label>
                    <div class="col-md-9">
                      <date-picker type="datetime" input-class="form-control" v-model="filter.created_at" range
                                   lang="en" format="YYYY-MM-DD" confirm id="created_at"
                                   value-type="YYYY-MM-DD"></date-picker>
                    </div>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9">
                      <button type="submit" class="btn btn-common m-2px"><i class="fas fa-search"></i> Search</button>
                      <button type="reset" class="btn btn-warning" @click="resetFilter()"><i class="fas fa-undo"></i>
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="card-body table-responsive-md p-0">
            <div class="overlay text-center" v-if="is_loading">
              <img :src="getImage('logo.svg')" class="loader-img" alt="loader">
            </div>
            <table class="table">
              <thead>
              <tr>

                <th style="width: 10px">
                  <input type="checkbox" v-model="is_selected_all" @click="selectedRowAll()">
                </th>

                <th>Sender
                  <sort-icons :_sort="'sender_user_id'"/>
                </th>
                <th>Receiver
                  <sort-icons :_sort="'receiver_user_id'"/>
                </th>
                <th>Activity Type
                  <sort-icons :_sort="'trx_activity_type_id'"/>
                </th>
                <th>Amount
                  <sort-icons :_sort="'trx_amount'"/>
                </th>
                <th>Type
                  <sort-icons :_sort="'trx_type'"/>
                </th>

                <th>Note
                  <sort-icons :_sort="'trx_note'"/>
                </th>

                <th>UUID
                  <sort-icons :_sort="'trx_uuid'"/>
                </th>
                <th>Reference
                  <sort-icons :_sort="'trx_reference'"/>
                </th>
                <th>Balance
                  <sort-icons :_sort="'balance'"/>
                </th>
                <th>Is Charge
                  <sort-icons :_sort="'is_charge'"/>
                </th>
                <th>CreateTime
                  <sort-icons :_sort="'created_at'"/>
                </th>
                <th class="text-right">Action</th>

              </tr>
              </thead>
              <tbody class="list">
              <tr v-for="(val, index) in list.data">

                <td>
                  <input type="checkbox" v-model="selected_row" :value="val.id">
                </td>

                <td>{{ val.sender_user.username }}</td>
                <td>{{ val.receiver_user.username }}</td>
                <td>{{ !_.isEmpty(val.trx_activity_type) ? val.trx_activity_type.activity_type : 'NA' }}</td>
                <td>{{ parseFloat(val.trx_amount).toFixed(2) }}</td>
                <td>{{
                    !_.isEmpty(val.trx_type) ? val.trx_type.charAt(0).toUpperCase() + val.trx_type.slice(1) : 'NA'
                  }}
                </td>
                <td>{{ !_.isEmpty(val.trx_note) ? val.trx_note : "" }}</td>
                <td>{{ !_.isEmpty(val.trx_uuid) ? val.trx_uuid : "" }}</td>
                <td>{{ !_.isEmpty(val.trx_reference) ? val.trx_reference : "" }}</td>
                <td>{{ !_.isEmpty(val.balance) ? parseFloat(val.balance).toFixed(2) : 0 }}</td>
                <td>{{
                    !_.isEmpty(val.is_charge) ? val.is_charge.charAt(0).toUpperCase() + val.is_charge.slice(1) : 'no'
                  }}
                </td>
                <td>{{ customFormatter(val.created_at, 'lll') }}</td>
                <td class="text-right">
                  <router-link v-if="actionView == true" :to="{ name: 'EWTrxHistoryShow', params: { id: val.id }}"
                               class="btn btn-info btn-sm m-2px">
                    <i class="fas fa-eye"></i>
                  </router-link>
                  <router-link v-if="actionEdit == true && checkEditPermission(val)"
                               :to="{ name: 'EWTrxHistoryEdit', params: { id: val.id }}"
                               class="btn btn-info btn-sm m-2px">
                    <i class="fas fa-pencil-alt"></i>
                  </router-link>
                  <!--                  <a v-if="actionDelete == true && checkDeletePermission(val)" class="btn btn-danger btn-sm m-2px"
                  href="javascript:void(0)" @click="deleteObject(val.id, index)"><i class="fas fa-trash"></i></a>-->
                </td>

              </tr>
              </tbody>
            </table>
            <div class="p-4" v-if="empty && is_loading == false">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>

          <div class="card-footer">
            <vue-pagination
              :pagination="list"
              v-if="list.total > list.per_page"
              @paginate="reload()"
            ></vue-pagination>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from '@/components/partials/PaginationComponent'
import SortIcons from '@/components/utils/SortIcons'
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import {CommonAPI, PermissionChecker} from '@/services/api'
import {mapGetters, mapActions} from 'vuex'
import moment from 'moment'
import {Notification} from 'element-ui'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const fileDownload = require('js-file-download')

export default {
  name: 'EWTrxHistory',
  metaInfo: {
    title: ' Transaction Histories | Dotlines'
  },
  components: {
    DatePicker, VuePagination, SortIcons
  },
  data: () => ({
    list: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1
    },
    actionCreate: false,
    actionView: true,
    actionEdit: true,
    actionDelete: true,
    api_url: '',
    showFilter: false,
    filter: {},
    dateRange: '',
    pre: [],
    is_loading: false,
    empty: false,
    empty_message: '',
    custom_permission_data: [],
    has_permission: true,
    selected_row: [],
    is_selected_all: false,
    activityTypes: []
  }),
  mounted: function () {
    this.getActivityTypes()
    if (this.isMobile()) {
      //window.$(document).find('.push-menu-class').trigger('click');
      window.$("body").removeClass("sidebar-open")
      window.$("body").addClass("sidebar-closed sidebar-collapse")
    }
    this.api_url = '/ew_trx_histories'
    this.initialize()
    this.$root.$on('sort-data', () => {
      this.$root.$emit('show-icon')
      this.reload()
    });
  },
  computed: {
    ...mapGetters(['profile'])
  },
  methods: {
    customFormatter(date, format = 'MMM Do YY, h:mm:ss a') {
      return moment(date).format(format);
    },
    async initialize() {
      this.is_loading = true
      // eslint-disable-next-line no-undef
      if (_.isEmpty(this.profile)) {
        // eslint-disable-next-line camelcase
        await CommonAPI.getProfile().then(profile_info => {
          // eslint-disable-next-line camelcase
          this.user_detail = profile_info
        })
      } else {
        this.user_detail = this.profile
      }

      await CommonAPI.getCustomPermission('/get-custom-permission-infos?path=api/ew_trx_histories').then(response => {
        // eslint-disable-next-line eqeqeq
        if (response.status == 200) {
          this.custom_permission_data = response.data
        }
      });

      // eslint-disable-next-line no-undef
      if (!_.isEmpty(this.custom_permission_data)) {
        this.actionCreate = await PermissionChecker.checkCreateButtonPermission(this.custom_permission_data.action_permission,
          this.custom_permission_data['create_id_condition'], this.user_detail, this.custom_permission_data.enableAdministratorPermissionByDefault)
      }

      await this.getList().then(response => {
        this.list = response.data
      }).catch(error => {
        this.empty = true
        if (error.response.status === 403) {
          this.has_permission = false
        }
      });
      this.is_loading = false
    },
    async getFilterData() {
      this.is_loading = true
      await this.getList().then(response => {
        this.list = response.data
      }).catch(error => {
        this.empty = true
        if (error.response.status === 403) {
          this.has_permission = false
        }
      })
      this.is_loading = false
    },
    reload: function () {
      this.getList().then(response => {
        this.list = response.data
      }).catch(error => {
        this.empty = true
        if (error.response.status === 403) {
          this.has_permission = false
        }
      })
    },
    getList: function () {
      return new Promise((resolve, reject) => {
        /* let params = {page: this.list.current_page}
        params = {...this.filter, ...this.$route.query, ...params} */
        const params = {...this.filter, ...this.$route.query}
        axios.get(this.api_url, {
          params: params
        }).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
          //console.log("error", error.response.data);
        }).finally(() => {
          //_this.is_loading = false;
        })
      })
    },
    checkEditPermission: function (data) {
      // eslint-disable-next-line no-undef
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkEditButtonPermission(this.custom_permission_data.action_permission, this.custom_permission_data['edit_id_condition'],
          this.custom_permission_data['edit_refid_condition'], this.custom_permission_data['edit_custom_condition'], data, this.user_detail, this.custom_permission_data.enableAdministratorPermissionByDefault, this.custom_permission_data['operator_between_block_condition_rules'])
      } else {
        return false
      }
    },
    checkDeletePermission: function (data) {
      // eslint-disable-next-line no-undef
      if (!_.isEmpty(this.custom_permission_data)) {
        return PermissionChecker.checkDeleteButtonPermission(this.custom_permission_data.action_permission, this.custom_permission_data['delete_id_condition'],
          this.custom_permission_data['delete_refid_condition'], this.custom_permission_data['delete_custom_condition'], data, this.user_detail, this.custom_permission_data.enableAdministratorPermissionByDefault, this.custom_permission_data['operator_between_block_condition_rules'])
      } else {
        return false
      }
    },
    async resetFilter() {
      this.list.current_page = 1
      this.filter = {}
      this.is_loading = true
      await this.getList().then(response => {
        this.list = response.data
      }).catch(error => {
        this.empty = true

        if (error.response.status === 403) {
          this.has_permission = false
        }
      })
      this.is_loading = false
    },
    deleteObject: function (id, index) {
      const _this = this
      let delete_api_url = '/ew_trx_histories/' + id

      _this.$swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        if (result.isConfirmed) {
          _this.is_loading = true
          axios.delete(delete_api_url)
            .then(response => {
              _this.list.data.splice(index, 1)
              _this.$toaster.success(response.data.message)
              _this.is_loading = false
            })
            .catch(error => {
              _this.is_loading = false
              console.log(error)
              _this.$swal.fire(
                "Failed!",
                "failed to delete.",
                "error"
              )
            })
            .finally(() => {
              _this.is_loading = false
            });
        }
      });
    },
    exportFile: function () {
      this.is_loading = true
      axios.get("/ew-trx-histories-export", {responseType: "blob"})
        .then(response => {
          fileDownload(response.data, "trx_histories.xlsx")
        })
        .catch((error) => {
          console.error('error ' + error)
        })
        .finally(() => {
          this.is_loading = false
          Notification.success({
            title: 'Export Completed',
            message: 'Export operation completed successfully',
            type: 'success'
          })
        });
    },
    selectedRowAll: function () {
      let isSelectedAll = this.is_selected_all = !this.is_selected_all
      if (isSelectedAll) {
        var items = []
        this.list.data.forEach(function (item) {
          items.push(item.id)
        })
        this.selected_row = items
      } else {
        this.selected_row = []
      }
    },
    handleSelectedRows(command) {
      if (command === 'delete') {
        axios({
          method: 'delete',
          url: '/ew_trx_histories/delete-all',
          data: {'ids': this.selected_row},
          headers: {'Content-Type': 'application/json'},
        }).then(function (response) {
          Notification.success({title: 'Deleted Successfully', message: 'Data deleted successfully', type: 'success'})
          this.initialize()
        }).catch((errors) => {
          // eslint-disable-next-line no-undef
          if (!_.isEmpty(errors.response) && errors.response.status === 500) {
            this.$toaster.error(errors.response.data.message)
          }
        }).finally(() => {
          this.is_selected_all = false
          this.initialize()
        });
      }
    },
    getActivityTypes: function () {
      this.is_loading = true
      axios.get("/get-trx-activity-types")
        .then(response => {
          // console.log('response', response)
          this.activityTypes = response.data
        })
        .catch((error) => {
          console.error('error ' + error)
        })
        .finally(() => {
          this.is_loading = false
        });
    },
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>
